import { useMemo } from 'react';
import type { Href } from 'expo-router';

import { useLastInteractedStore } from '../useLastInteractedStore';

// ─────────────────────────────────────────────────────────────────────────────

export const useLastInteractedStoreMenuHref = () => {
  const lastInteractedStore = useLastInteractedStore();

  const { addressId, restaurantSlug } = lastInteractedStore ?? {};

  return useMemo<Href>(() => {
    if (addressId) {
      return { pathname: '/delivery/[addressId]/menu', params: { addressId } };
    }

    if (restaurantSlug) {
      return { pathname: '/[restaurantSlug]/menu', params: { restaurantSlug } };
    }

    return '/location-selection';
  }, [addressId, restaurantSlug]);
};
